import React, { ReactText, FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '@root-gipro/shared/Loader/Loader'
import { Rates } from '@root-gipro/modules/commonProjects/components'
import {
	downloadCommonProject,
	getUncsCommonProject,
	addToUserProject,
} from '@root-gipro/modules/commonProjects/store/actions'
import { IState } from '@root-gipro/store/interfaces/state'

const RatesContainer: FC = () => {
	const { selectedProject, selectedProjectUncs, idAddedUserProject } = useSelector(
		(state: IState) => state.commonProjects
	)
	const { policesRGCO, policesGipro } = useSelector((state: IState) => state.public)
	const dispatch = useDispatch()

	return selectedProject ? (
		<Rates
			uncs={selectedProjectUncs}
			selectedProject={selectedProject}
			getUncsCommonProject={(id: ReactText) => dispatch(getUncsCommonProject(id))}
			downloadCommonProject={(id: ReactText, code: string) => dispatch(downloadCommonProject(id, code))}
			addToUserProject={(projectId: ReactText) => dispatch(addToUserProject(projectId))}
			policesRGCO={policesRGCO}
			policesGipro={policesGipro}
			idAddedUserProject={idAddedUserProject}
		/>
	) : (
		<Loader />
	)
}

export default RatesContainer
